/**
 * holds event names for SignalR
 */
export const StreamEvents = {
    /**
     * the old setToken,
     * send when user has been authenticated
     * from FE to BE
     */
    onUserAuthenticated: 'OnUserAuthenticated',

    onUserLogout: 'OnUserLogout',

    /**
     * send in PageContent when reconnection was succesfull by ReconnectionManager
     * from FE to BE
     */
    onUserReconnected: 'OnUserReconnected',

    /**
     * FE sends updated user state to BE
     * from FE to BE
     */
    onUserStateChanged: 'OnUserStateChanged',

    /**
     * BE sends array of user states to FE on connect
     * FE picks matching tabId or most recent on ems
     * from BE to FE
     */
    onUserStateRestored: 'OnUserStateRestored',

    // ADDED — BE pushes entries for active TopicGroup to specific connection after OnUserAuthenticated
    onTopicGroupUpdated: 'OnTopicGroupUpdated',

    // ADDED — BE pushes swap command when entry moves from one node to another
    onTopicEntrySwapped: 'OnTopicEntrySwapped',

    // ADDED — BE pushes resolved nodes for an entry after update
    onEntryNodesResolved: 'OnEntryNodesResolved',

    // ADDED — BE pushes all UserState2 entries for this user on connect
    onUserStateV2Restored: 'OnUserStateV2Restored',
};
